import { type VideoFieldsFragment } from '../../__generated__/graphql-client-types';
import { type FaqTabData, type ToolsTabData } from '../../types/project-about.types';

export const HERO_DESKTOP_PUBLIC_ID = '/siteassets/projects/about-page/projects-about-page-hero.png';
export const HERO_MOBILE_PUBLIC_ID = '/siteassets/projects/about-page/projects-about-page-hero-mobile.png';
export const HEADER_DESCRIPTION = 'The easiest way to plan, organize, and track your project from start to finish.';

export const VISIT_SHOWROOM_CARD_TITLE = 'Visit us at your nearest Showroom';
export const VISIT_SHOWROOM_CARD_COPY = 'Our expert associates are ready to help you with your Ferguson Home Project';

export const TOOLS_DESKTOP_IMAGES = {
	organize: '/siteassets/projects/about-page/organize_desktop.jpg',
	collaborate: '/siteassets/projects/about-page/collaborate_desktop.jpg',
	track: '/siteassets/projects/about-page/track_desktop.jpg'
};
export const TOOLS_MOBILE_IMAGES = {
	organize: '/siteassets/projects/about-page/organize_mobile.jpg',
	collaborate: '/siteassets/projects/about-page/collaborate_mobile.jpg',
	track: '/siteassets/projects/about-page/track_mobile.jpg'
};

const TRACK_TAB_DATA: ToolsTabData = {
	name: 'Track',
	description: 'Monitor progress and changes',
	bulletpoints: [
		'Get notified on product price and stock changes',
		'Stay up to date on all orders',
		'Keep track of changes or modifications'
	]
};
export const HOMEOWNERS_TAB_DATA: ToolsTabData[] = [
	{
		name: 'Organize',
		description: 'Stay organized throughout your entire project',
		bulletpoints: ['Name your project and organize items by group', 'Add and remove products', 'Keep track of all orders']
	},
	{
		name: 'Collaborate',
		description: 'Work together to bring your project to life',
		bulletpoints: [
			'Invite collaborators and our Ferguson Home experts to help with planning',
			'Keep information centralized and readily available'
		]
	},
	TRACK_TAB_DATA
];

export const PROS_TAB_DATA: ToolsTabData[] = [
	{
		name: 'Organize',
		description: 'Stay organized as your project progresses',
		bulletpoints: [
			'Name your project and organize items by group',
			'Add and remove products',
			'Save spec sheets for quick access',
			'Export your projects as a portfolio'
		]
	},
	{
		name: 'Collaborate',
		description: 'Work together to bring your project to life',
		bulletpoints: [
			'Manage access levels based on need, whether client, colleague or Ferguson Home project expert',
			'Keep information centralized and readily available'
		]
	},
	TRACK_TAB_DATA
];

export const FAQ_DATA: FaqTabData[] = [
	{
		question: 'Is the Project Tool Free?',
		answer: 'Yes! The Project Tool is free to use.'
	},
	{
		question: 'How Does the Project Tool Work?',
		answer: 'The Ferguson Home Project Tool is a project management tool that helps homeowners and professionals organize and compare the items and appliances needed to create and design their projects. Create projects based on room type, add and compare products, and collaborate with clients and consultants on the perfect design.'
	},
	{
		question: 'What Projects Can I Build Using the Project Tool?',
		answer: 'The Project Tool is flexible to adapt to your specific needs. You can choose between predefined or custom names when creating your product groups to organize your project however works best for you!'
	},
	{
		question: 'Can I Compare Products?',
		answer: 'Yes. You can compare two to four products for your room design. The Project Tool will generate a printable table that compares prices, shipping estimates, stocking info, specs, features, warranties, and more for the selected products.'
	},
	{
		question: 'What is the Portfolio Feature?',
		answer: 'You can choose to export your project as a portfolio to generate a professional report for collaborating with clients, professionals, and whomever you need to view selected products and optionally include specs for their project.'
	},
	{
		question: 'Are Projects Automatically Updated When Prices/Stocking Changes?',
		answer: 'Yes, all pricing and stocking changes are updated live in your project. You can always reference the notifications and activity section of your project to keep track of any changes in price and stock availability.'
	},
	{
		question: 'Do I Need an Account to Use the Tool?',
		answer: 'No, you do not need an account to start using projects. We do recommend creating an account to save your project and access additional features. '
	}
];

export const PROMO_VIDEO_TITLE = 'Where Organization Meets Inspiration';
export const PROMO_VIDEO_DESCRIPTION =
	'See how designers use the Ferguson Home project tool to streamline specifications, stay organized, and create meaningful spaces for their clients.';

export const PROJECT_TOOL_VIDEO: VideoFieldsFragment = {
	streamProviderCode: 1,
	title: 'Ferguson Home Project Tool',
	description: 'Ferguson Home Project Tool',
	id: '0',
	hashKey: 'dm36dh13zr',
	screenshotId: 0
};
